import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'report_FreightReport'

  static get fields () {
    return {
      id: new UUID(),
      date_from: new DATETIME(),
      date_to: new DATETIME(),
      account_id: new UUID(),
      showChildrenAccts: new BOOLEAN(),
      showBilledOnly: new BOOLEAN(),
      internalConsOnly: new BOOLEAN(),
      unDeliveredOnly: new BOOLEAN(),
      carrier_id: new UUID(),
      getInvoiceData: new BOOLEAN(),
      showDifotData: new BOOLEAN(),
      showMarginData: new BOOLEAN(),
      includeUndeliveredFreightStats: new BOOLEAN()
    }
  }
}
